module.exports = __webpack_public_path__ + "img/platform-activities-success-wall.253bdd80.png";